import axios from "axios";
import { keycloak } from "../../../../lib/keycloak";
import { CreateLegalRepresentativeDTO, FindAllLegalRepresentativesFiltersDTO, FindAllLegalRepresentativesResponseDTO, LegalRepresentativesResponseDTO, UpdateLegalRepresentativeDTO } from "./dto";
import { LegalRepresentativeService } from "./service";

export class LegalRepresentativeServiceImpl implements LegalRepresentativeService {
    public createLegalRepresentative(data: CreateLegalRepresentativeDTO): Promise<number> {
        return axios.post("/api/legal-representive",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public updateLegalRepresentative(id: string, data: UpdateLegalRepresentativeDTO): Promise<void> {
        return axios.put("/api/legal-representive/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public findAllLegalRepresentatives(filters: FindAllLegalRepresentativesFiltersDTO): Promise<FindAllLegalRepresentativesResponseDTO> {
        return axios.get("/api/legal-representive", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page,
                order: filters.order,
                sort: filters.sort,
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public getLegalRepresentativeById(id: string): Promise<LegalRepresentativesResponseDTO> {
        return axios.get("/api/legal-representive/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public deleteLegalRepresentative(id: string): Promise<void> {
        return axios.delete("/api/legal-representive/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "DELETE",
            }
        }).then((response) => response.data)
    }

    public removeLegalRepresentative(id: string): Promise<void> {
        return axios.put(
            "/api/legal-representive/remove/" + id,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    ContentType: 'application/json',
                    "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "DELETE",
                }
            }
        ).then((response) => response.data)
    }
}
